
import {Component, Vue} from 'vue-property-decorator'
import {Form} from 'element-ui'
import {cloneDeep} from 'lodash'
import {
  createJobPosition,
  defaultJobPositionData,
  deleteJobPosition,
  getJobPositionList,
  updateJobPosition
} from "@/api/job-position";
import {IJobPositionModel} from '@/api/types'
import Pagination from '@/components/Pagination/index.vue'


@Component({
  name: 'JobPositionManagement',
  components: {
    Pagination
  },
})
export default class extends Vue {
  private tableKey = 0
  private jobPositionList: IJobPositionModel[] = []
  private total = 0
  private listLoading = true

  private dialogFormVisible = false
  private dialogStatus = ''
  private textMap = {
    update: '编辑',
    create: '新增'
  }

  private dialogPageviewsVisible = false
  private pageviewsData = []
  private rules = {
    type: [{required: true, message: 'type is required', trigger: 'change'}],
    timestamp: [{required: true, message: 'timestamp is required', trigger: 'change'}],
    title: [{required: true, message: 'title is required', trigger: 'blur'}],
    name: [{required: true, message: '名称不能为空', trigger: 'blur'}]
  }

  private downloadLoading = false
  private tempPositionData = defaultJobPositionData

  created() {
    this.getList()
  }

  private async getList() {
    this.listLoading = true
    const data: any = await getJobPositionList()
    this.jobPositionList = data
    setTimeout(() => {
      this.listLoading = false
    }, 0.5 * 1000)
  }

  private resetTempData() {
    this.tempPositionData = cloneDeep(defaultJobPositionData)
  }

  private handleCreate() {
    this.resetTempData()
    this.dialogStatus = 'create'
    this.dialogFormVisible = true
    this.$nextTick(() => {
      (this.$refs.dataForm as Form).clearValidate()
    })
  }

  private createData() {
    (this.$refs.dataForm as Form).validate(async(valid) => {
      if (valid) {
        const name = this.tempPositionData.name
        await createJobPosition({"name": name})
        this.dialogFormVisible = false
        this.$notify({
          title: '成功',
          message: '创建成功',
          type: 'success',
          duration: 2000
        })
        await this.getList()
      }
    })
  }

  private onUpdate(row: any) {
    this.tempPositionData = Object.assign({}, row)
    // this.tempPositionData.timestamp = +new Date(this.tempPositionData.timestamp)
    this.dialogStatus = 'update'
    this.dialogFormVisible = true
    this.$nextTick(() => {
      (this.$refs.dataForm as Form).clearValidate()
    })
  }

  private updateData() {
    (this.$refs.dataForm as Form).validate(async(valid) => {
      if (valid) {
        await updateJobPosition(this.tempPositionData.id, {name: this.tempPositionData.name})
        this.dialogFormVisible = false
        this.$notify({
          title: '成功',
          message: '更新成功',
          type: 'success',
          duration: 2000
        })
        await this.getList()
      }
    })
  }

  private async onDelete(row: IJobPositionModel, index: number) {
    await deleteJobPosition(row.id)
    this.$notify({
      title: 'Success',
      message: 'Delete Successfully',
      type: 'success',
      duration: 2000
    })
    await this.getList()
  }


}
